import ActivityPage from './activityPage'
import { activityMenu } from './sideBarOption'

export { activityMenu }
export default ActivityPage
